import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SkeletonCircle, SkeletonLine } from './Skeleton';

const columnWidthPattern = ['86%', '72%', '64%', '78%', '58%', '68%'];

const TableSkeleton = ({
	rows,
	columns,
	className,
	responsive,
	showIndexColumn,
	showAvatarColumn,
}) => {
	const headerColumns = Array.from({ length: columns }, (_, columnIndex) => ({
		id: `head-${columnIndex + 1}`,
		width: columnWidthPattern[columnIndex % columnWidthPattern.length],
	}));
	const bodyRows = Array.from({ length: rows }, (__, rowIndex) => ({
		id: `row-${rowIndex + 1}`,
		cells: Array.from({ length: columns }, (_, columnIndex) => ({
			id: `cell-${rowIndex + 1}-${columnIndex + 1}`,
			isAvatarCell: showAvatarColumn && columnIndex === 0,
			width: columnWidthPattern[(rowIndex + columnIndex) % columnWidthPattern.length],
		})),
	}));

	const table = (
		<table className={classNames('table table-modern mb-0', className)}>
			<thead>
				<tr>
					{showIndexColumn && (
						<th scope='col' style={{ width: '72px' }}>
							<SkeletonLine width='40%' height='0.9rem' />
						</th>
					)}
					{headerColumns.map((column) => (
						<th key={column.id} scope='col'>
							<SkeletonLine width={column.width} height='0.9rem' />
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{bodyRows.map((row) => (
					<tr key={row.id}>
						{showIndexColumn && (
							<th scope='row' style={{ width: '72px' }}>
								<SkeletonLine width='28%' height='0.9rem' />
							</th>
						)}
						{row.cells.map((cell) => (
							<td key={cell.id}>
								<div className='d-flex align-items-center gap-2'>
									{cell.isAvatarCell && <SkeletonCircle size='2rem' />}
									<SkeletonLine
										width={cell.isAvatarCell ? '68%' : cell.width}
										height='0.875rem'
									/>
								</div>
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);

	if (!responsive) {
		return table;
	}

	return <div className='table-responsive'>{table}</div>;
};

TableSkeleton.propTypes = {
	rows: PropTypes.number,
	columns: PropTypes.number,
	className: PropTypes.string,
	responsive: PropTypes.bool,
	showIndexColumn: PropTypes.bool,
	showAvatarColumn: PropTypes.bool,
};

TableSkeleton.defaultProps = {
	rows: 5,
	columns: 4,
	className: null,
	responsive: true,
	showIndexColumn: true,
	showAvatarColumn: false,
};

export default TableSkeleton;
